import React from "react";

import { WithTranslation, withTranslation } from "react-i18next";
import { shopConfig } from "~/helpers/shopConfig";
import styled from "~/styled";
import { IGiftCard as IProps } from "../../graphql/queries/giftCard/giftCardByCode";

const GiftCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  margin: 20px auto;
  padding: 25px;
  background: ${props => props.theme.brandColor.primary};
  box-shadow: 0px 25px 45px -30px ${props => props.theme.brandColor.primary};
  border-radius: 10px;
  position: relative;
  overflow: hidden;
`;

const CardBalance = styled.div`
  display: flex;
  justify-content: space-between;
  color: #fff;
  text-shadow: 1px 1px 0px #000;
  z-index: 1;
`;

const CardBrand = styled.div`
  display: flex;
  justify-content: center;
  font-size: 36px;
  color: #fff;
  text-shadow: 1px 1px 0px #000;
  margin: 25px 0;
  z-index: 1;
`;

const CardExpiration = styled.div`
  display: flex;
  justify-content: flex-end;
  color: #fff;
  text-shadow: 1px 1px 0px #000;
  z-index: 1;
`;

const WaweBackdrop = styled.div`
  top: 30%;
  left: 30%;
  width: 400px;
  height: 400px;
  background-color: #fff;
  opacity: 0.6;
  position: absolute;
  border-radius: 50%;
`;

class GiftCard extends React.Component<WithTranslation & IProps> {
  public render() {
    const { t, balance, expiresOn, maskedCode, initialValue } = this.props;

    return (
      <>
        <GiftCardWrapper>
          <CardBalance>
            <p>{maskedCode.toUpperCase()}</p>
            <p>
              {balance.amount} {balance.currencyCode}
              {initialValue
                ? " / " + initialValue.amount + " " + initialValue.currencyCode
                : null}
            </p>
          </CardBalance>

          <CardBrand>{shopConfig.brandName}</CardBrand>

          <CardExpiration>{expiresOn}</CardExpiration>

          <WaweBackdrop />
        </GiftCardWrapper>

        {expiresOn ? (
          <p
            dangerouslySetInnerHTML={{
              __html: t("cardFound.descriptionWithDate", {
                balance: balance.amount,
                currencyCode: balance.currencyCode,
                expirationDate: expiresOn
              })
            }}
          />
        ) : (
          <p
            dangerouslySetInnerHTML={{
              __html: t("cardFound.descriptionWithoutDate", {
                balance: balance.amount,
                currencyCode: balance.currencyCode
              })
            }}
          />
        )}
      </>
    );
  }
}

export default withTranslation("giftcard")(GiftCard);



// WEBPACK FOOTER //
// ./src/components/GiftCard/GiftCard.tsx